import { Injectable  } from '@angular/core';

@Injectable ()
export class InvoiceService {
  invoice: number;

  setInvoice(value) {
    this.invoice = value;
  }
  getInvoice() {
    return this.invoice;
  }

}
